import {message} from 'antd';
import PropTypes from 'prop-types';
import React, {useEffect} from 'react';

interface IProps {
  errorMessage: string;
  isSnackBarOpen: any;
  closeSnackBar: any;
  clearMessageOnClose?: any;
  severity?: any;
}

const AUTO_HIDE_DURATION_S = 10;

// Same controlled prop contract as before (isSnackBarOpen/closeSnackBar/errorMessage/
// clearMessageOnClose/severity) so every existing call site (32 of them app-wide)
// keeps working unchanged. Internally this now renders via antd's message API
// instead of a bespoke fixed-position Alert, so every toast in the app — this
// component plus Login/SSOLogin, which already used message directly — shares
// the same look, position, and animation. One behavior change: antd's message
// has no manual close button (matching Login/SSOLogin's existing toasts), so
// dismissal is auto-only after the same 10s duration as before.
const SnackBar: React.FC<IProps> = (props) => {
  const {
    errorMessage,
    closeSnackBar,
    isSnackBarOpen,
    clearMessageOnClose = () => {},
    severity,
  } = props;
  const [messageApi, contextHolder] = message.useMessage();

  const handleClose = () => {
    closeSnackBar();
    clearMessageOnClose();
  };

  useEffect(() => {
    if (!isSnackBarOpen) return;
    messageApi.open({
      type: severity || 'error',
      content: errorMessage,
      duration: AUTO_HIDE_DURATION_S,
      onClose: handleClose,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSnackBarOpen]);

  return contextHolder;
};

SnackBar.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  closeSnackBar: PropTypes.func.isRequired,
  clearMessageOnClose: PropTypes.func,
  isSnackBarOpen: PropTypes.bool.isRequired,
};

export default SnackBar;
